import { DEMO_PHONE, INDUSTRIES } from '@/landing/content'
import { ContentPage, contentMeta, type ContentPageData } from '@/site/content'

const sample = INDUSTRIES.find((i) => i.key === 'beauty')!

const page: ContentPageData = {
  path: '/dlya/saloniv-krasy',
  parent: { name: 'Галузі', path: '/dlya' },
  crumb: 'Салони краси',
  title: 'AI-адміністратор для салону краси | Anytel',
  description:
    'AI-адміністратор приймає дзвінки салону краси 24/7: знає майстрів і послуги, пропонує вільний час і записує клієнтів навіть уночі й у вихідні.',
  eyebrow: 'Для салонів краси й барбершопів',
  h1: 'AI-адміністратор для салону краси',
  lead:
    'Майстри зайняті клієнтами, адміністратор розраховує й варить каву, а телефон дзвонить. AI-агент записує клієнтів до потрібного майстра, відповідає про послуги й ціни і працює навіть тоді, коли салон зачинено.',
  sections: [
    {
      h2: 'Чому салон втрачає записи',
      blocks: [
        'Більшість клієнтів салону записуються телефоном або в месенджері, і роблять це, коли їм зручно: дорогою з роботи, увечері, у неділю. Якщо в цей момент ніхто не відповів, клієнтка записується туди, де відповіли.',
        {
          list: [
            'Адміністратор розраховує клієнтку, а на лінії інша, яка хоче записатися.',
            'Майстер працює сам і не може відірватися від клієнта, щоб узяти трубку.',
            'Записатися хочуть о 22:00, а салон відкривається о 10:00.',
          ],
        },
      ],
    },
    {
      h2: 'Що робить AI-адміністратор',
      blocks: [
        { h3: 'Знає майстрів і послуги' },
        'Хто з майстрів робить яку послугу, скільки вона триває і скільки коштує. Агент не запише фарбування на пів години і не запропонує манікюр у барбера.',
        { h3: 'Пропонує вільний час' },
        'Замість «передзвоніть пізніше» агент одразу називає найближчі вільні вікна в потрібного майстра і записує. Подвійних записів не буде: календар не дасть поставити двох клієнтів на один час.',
        { h3: 'Записує вночі й у вихідні' },
        'Агент працює цілодобово, тож записи приймаються і тоді, коли салон зачинено. Зранку майстри бачать свій день уже заповненим.',
        { h3: 'Відповідає в месенджерах' },
        'Той самий агент з тими самими знаннями відповідає в Instagram, Telegram і Viber. Клієнтка, яка написала в директ, отримує відповідь за секунди, а не після зміни.',
      ],
    },
  ],
  dialog: {
    h2: 'Приклад розмови',
    context: 'Салон краси, четвер, 21:47',
    dialog: sample.dialog,
    result: sample.result,
  },
  after: [
    {
      h2: 'Що бачить салон',
      blocks: [
        'Записи з’являються в календарях майстрів, а нові записи приходять сповіщенням [у Telegram](/funktsii/zayavky-v-telegram) адміністратору. Розмови записані й розшифровані: якщо клієнтка каже, що просила інший відтінок, це легко перевірити.',
        'Постійних клієнток можна вести в контактах, з історією дзвінків, повідомлень і записів.',
      ],
    },
    {
      h2: 'Як підключити салон',
      blocks: [
        {
          steps: [
            { title: 'Майстри і послуги', text: 'Додайте майстрів, їхні послуги з тривалістю й цінами і графік роботи кожного.' },
            { title: 'Тестовий дзвінок', text: 'Поговоріть з агентом з браузера як клієнтка: спробуйте записатися, запитати ціну, змінити час.' },
            { title: 'Номер і месенджери', text: 'Увімкніть переадресацію з номера салону і підключіть Instagram чи Telegram, якщо клієнти пишуть туди.' },
          ],
        },
      ],
    },
  ],
  faq: [
    {
      q: 'Клієнтка хоче перенести запис. Агент впорається?',
      a: 'Агент приймає прохання про перенесення і передає його адміністратору разом з бажаним часом. Сам перенести наявний запис він поки не може: це робить адміністратор у кабінеті.',
    },
    {
      q: 'Майстри працюють за різним графіком. Це враховується?',
      a: 'Так. У кожного майстра свій календар з робочими днями, годинами і вихідними. Агент пропонує лише той час, коли майстер працює і вільний.',
    },
    {
      q: 'Чи може агент розповісти про акції?',
      a: 'Так, якщо вони є в базі знань. Додали акцію в кабінеті, і агент розповідає про неї з наступного дзвінка.',
    },
    {
      q: 'Чи звучатиме агент як робот?',
      a: `Розмова йде в реальному часі: клієнтка може перебити, перепитати, змінити думку. Голос і манеру спілкування ви обираєте самі. Найкраще почути це на [демо-лінії](tel:${DEMO_PHONE}).`,
    },
  ],
  related: ['/dlya/stomatologii', '/funktsii/ai-agent-dlya-dzvinkiv', '/funktsii/robota-24-7', '/blog/yak-ne-vtrachaty-dzvinky-pislya-18'],
}

export const meta = contentMeta(page)

export default function Page() {
  return <ContentPage page={page} />
}
